import React, { useState } from "react";
import { Button } from "@mui/material";
import { Download } from "@mui/icons-material";
import moment from "moment";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { useLazyListBSLViewQuery } from "store/services/BranchShipmentLocationApi";

const TYPE_LABELS = {
  source: "Source",
  transit: "Transit",
  destination: "Destination",
};

const ExportBSLReportView = ({ filters, disabled = false }) => {
  const [isExporting, setIsExporting] = useState(false);
  const [exportBSLView] = useLazyListBSLViewQuery();

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const response = await exportBSLView({
        ...filters,
        page: 1,
        limit: 100000,
      }).unwrap();
      const data = response?.data || [];

      if (!data.length) {
        toast.info("No data to export");
        return;
      }

      const headers = [
        "Shipment ID",
        "Current Branch",
        "Branch Code",
        "Destination Branch",
        "Dest. Code",
        "Type",
        "Status",
        "Added By",
        "Added At",
      ];

      const rows = data.map((row) => [
        row.shipmentId || "N/A",
        row.currentBranch?.name || "N/A",
        row.currentBranch?.code || "N/A",
        row.destinationBranch?.name || "N/A",
        row.destinationBranch?.code || "N/A",
        TYPE_LABELS[row.type] || row.type || "N/A",
        row.shipmentStatus || "N/A",
        row.addedBy?.name || "N/A",
        row.addedAt ? moment(row.addedAt).format("YYYY-MM-DD HH:mm") : "N/A",
      ]);

      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

      worksheet["!cols"] = [
        { wch: 18 }, // Shipment ID
        { wch: 28 }, // Current Branch
        { wch: 14 }, // Branch Code
        { wch: 28 }, // Destination Branch
        { wch: 14 }, // Dest. Code
        { wch: 14 }, // Type
        { wch: 16 }, // Status
        { wch: 20 }, // Added By
        { wch: 20 }, // Added At
      ];
      worksheet["!autofilter"] = { ref: `A1:I${rows.length + 1}` };

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "BSL View");
      XLSX.writeFile(
        workbook,
        `bsl-shipment-view-${moment().format("YYYY-MM-DD")}.xlsx`,
      );
      toast.success(`Exported ${data.length} records successfully`);
    } catch (error) {
      toast.error(error?.data?.message || "Export failed");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button
      startIcon={<Download />}
      variant="outlined"
      size="small"
      onClick={handleExport}
      disabled={disabled || isExporting}
    >
      {isExporting ? "Exporting..." : "Export"}
    </Button>
  );
};

export default ExportBSLReportView;